import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectNeedRunJumpAnimation } from '../../../selectors/consultantChat';
import { toggleJumpAnimation } from '../../../actions/consultantChat';

interface IStandaloneChatWidgetDesktopAPI {
  triggerJumpAnimation: () => void;
}

export function useJumpAnimation() {
  const dispatch = useDispatch();
  const ref = useRef<IStandaloneChatWidgetDesktopAPI>(null);

  const needRunJumpAnimation = useSelector(selectNeedRunJumpAnimation);

  useEffect(() => {
    if (needRunJumpAnimation && ref.current) {
      ref.current.triggerJumpAnimation();
      dispatch(toggleJumpAnimation(false));
    }
  }, [dispatch, needRunJumpAnimation]);

  return ref;
}
